export const presetKeysClasses = {
  link: ["text_color", "underline", "pointer"],
  item: [
    "text_color_cape_cod",
    "text_active_color_deep_sea_green",
    "text_weight_bold",
    "no_underline"
  ],
  subitem: ["text_color_outer_space", "text_active_bold", "no_underline"],
  h2: ["text_weight_bold", "text_medium", "text_color_outer_space"]
}



// WEBPACK FOOTER //
// ./src/components/Typograph/preset.js